import { Navigate } from 'react-router-dom';
import BioView from 'pages/bio-view';
import useIsMobile from 'hooks/useIsMobile';

// Creative site is the landing page on desktop; it's desktop-only, so mobile goes to the resume.
const LandingRoute: React.FC = () => {
  const isMobile = useIsMobile();
  return isMobile ? <Navigate to="/resume" replace /> : <BioView />;
};

export default LandingRoute;
